<template>
  <div
    class="flex flex-col gap-2.5 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-700 rounded-md py-3.5 px-4"
  >
    <slot />
  </div>
</template>
